import numeral from 'numeral';

const keys = (isDark, t) => [
    {
        key: 'impressions',
        label: t('discover.entity.chart.impressions'),
        format: '0,00a',
        img: isDark ? '/static/img/file-search_dark.svg' : '/static/img/file-search.svg',
    },
    {
        key: 'clicks',
        label: t('discover.entity.chart.clicks'),
        format: '0,00a',
        yAxisID: 'y3',
        img: isDark ? '/static/img/cursor-click-01_dark.svg' : '/static/img/cursor-click-01.svg',
    },
    {
        key: 'ctr',
        label: t('discover.entity.chart.ctr'),
        format: '0.00%',
        render: (data) => numeral(data * 100).format('0.00'),
        yAxisID: 'y1',
        img: isDark ? '/static/img/cursor-box_dark.svg' : '/static/img/cursor-box.svg',
    },
];

export default keys;
